<template>
  <!-- edit mode -->
  <fieldset>
    <div
      v-for="(option, index) in options"
      :key="name + '-' + index"
      :data-test-selected="isSelected(option)"
      class="radio-inline"
    >
      <input
        :id="name + '-option-' + index"
        v-model="model"
        :name="name + '-option'"
        :value="option"
        :disabled="loading"
        :class="{ invalid: option.Value.ShouldBlock }"
        type="radio"
        @change="$emit('update:modelValue', model)"
      />
      <LabelAndTooltip
        :for="name + '-option-' + index"
        :label="option.Text"
        :tooltip="option.Tooltip"
      />
    </div>
  </fieldset>
</template>

<script>
import FormComponentMixin from './_FormComponentMixin';
import LabelAndTooltip from '@/components/UI/LabelAndTooltip.vue';

export default {
  name: 'RadioGroup',
  components: {
    LabelAndTooltip
  },
  mixins: [FormComponentMixin],
  props: {
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>
